import React from "react";
import {Link, withRouter} from "react-router-dom";
import {Col, Container, Row} from "react-bootstrap";
import {Button, Empty, Tabs, Spin} from "antd";
import HelperGeneral from "../../../helpers/HelperGeneral";
import moment from "moment";
import Api from "../../../services/Api";
import UserInfo from "../../auth/UserInfo";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faCalendarMinus,
    faTableCells,
    faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import _ from "lodash";
import {reduxStore} from "../../../services/redux/ReduxIndex";
import {connect} from "react-redux";

class Campaign extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active_tab: this.props?.match?.params?.tab_key,
            viewType: "card",
            loading: false,
            chartProgressStyle: {},
            currentCampaigns: [],
            previousCampaigns: [],
            futureCampaigns: [],
            expertBonus: [],
            menuBrandData: {},
        };
    }

    componentDidMount() {
        // this.getCampaignAll();
        // this.getCampaignUps();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const tab_key = this.props?.match?.params?.tab_key;
        if (this.state.active_tab !== tab_key) {
            this.setState({
                active_tab: tab_key,
            });
        }
    }

    getCampaignUps = () => {
        const user = UserInfo.info();
        const accountId = user?.id;
        const {menuData} = reduxStore.getState().GeneralReducer;

        this.setState({loading: true}, () => {
            if (menuData && menuData?.lists.length > 0) {
                const productMenuData = _.filter(menuData?.lists, [
                    "id",
                    "product",
                ]);
                const newMenuProduct = _.first(productMenuData);
                if (newMenuProduct) {
                    Api.getCampaignUps(accountId)
                        .then((e) => {
                            this.setState({
                                menuBrandData: newMenuProduct,
                                loading: false,
                                expertBonus: e.data?.result,
                            });
                        })
                        .catch((e) => {
                            this.setState({loading: false}, () =>
                                HelperGeneral.alert(e)
                            );
                        });
                }
            }
        });
    };

    getCampaignAll = () => {
        const user = UserInfo.info();
        const accountId = user?.id;

        this.setState({loading: true}, () => {
            Api.getCampaignAll(accountId)
                .then((e) => {
                    this.setState({
                        loading: false,
                        currentCampaigns: _.filter(e.data?.result, [
                            "campaignType",
                            1,
                        ]),
                        previousCampaigns: _.filter(e.data?.result, [
                            "campaignType",
                            2,
                        ]),
                        futureCampaigns: _.filter(e.data?.result, [
                            "campaignType",
                            3,
                        ]),
                    });
                })
                .catch((e) => {
                    this.setState({loading: false}, () =>
                        HelperGeneral.alert(e)
                    );
                });
        });
    };

    render() {
        const {
            active_tab,
            loading,
            currentCampaigns,
            previousCampaigns,
            futureCampaigns,
            expertBonus,
        } = this.state;

        const campaignViewSwitch = () => {
            return (
                <>
                    <div className={"campaign-type-back"}>
                        <Button
                            type={this.state.viewType === "graph" && "primary"}
                            className={
                                this.state.viewType === "graph" && "rounded"
                            }
                            onClick={() => this.setState({viewType: "graph"})}
                        >
                            <FontAwesomeIcon
                                icon={faCalendarMinus}
                                className={"me-2"}
                            /> {" "}Takvim
                        </Button>
                        <Button
                            type={this.state.viewType === "card" && "primary"}
                            className={
                                this.state.viewType === "card" && "rounded"
                            }
                            onClick={() => this.setState({viewType: "card"})}
                        >
                            <FontAwesomeIcon
                                icon={faTableCells}
                                className={"me-2"}
                            /> {" "} Pano
                        </Button>
                    </div>
                </>
            );
        };

        const expertBonusGraph = (data) => {
            const {menuBrandData} = this.state;
            let brands = menuBrandData?.submenu;

            return (
                <>
                    <div className={"product-history"}>
                        <h2 className={"mb-3"}>{data?.title}</h2>
                        <div className={"w-100 h-100 position-relative"}>
                            {
                                !loading && data?.progressObject?.length < 1 ? (
                                    <Empty
                                        description={"Pirim verisi bulunamadı"}
                                    />
                                ) : (
                                    <div className={"w-100 h-100 campaign-chart-back-border position-absolute"}>
                                        <Row className={"h-100"}>
                                            <Col xs={12} className={"h-100 mx-auto"}>
                                                <div className={"chart-back-border-column h-100"}/>
                                                <div className={"chart-back-border-column h-100"}/>
                                                <div className={"chart-back-border-column h-100"}/>
                                                <div className={"chart-back-border-column h-100"}/>
                                                <div className={"chart-back-border-column h-100"}/>
                                                <div className={"chart-back-border-column h-100"}/>
                                                <div className={"chart-back-border-column h-100"}/>
                                            </Col>
                                        </Row>
                                    </div>
                                )
                            }

                            <div style={{zIndex: 1, position: "relative"}}>
                                {
                                    data?.campaignType !== 9 && (
                                        <Row className={"mt-5 mb-3"}>
                                            <Col xs={12} md={8} lg={4} className={"mt-4 mx-auto d-flex align-items-center p-2 justify-content-center"}>
                                                <Row>
                                                    {
                                                        brands && (
                                                            brands.map((v2, i2) => (
                                                                <Col xs={true} key={i2}>
                                                                    <img src={v2.image} className={"img-fluid"}/>
                                                                </Col>
                                                            ))
                                                        )
                                                    }
                                                </Row>
                                            </Col>
                                        </Row>
                                    )
                                }
                                {
                                    data?.progressObject?.map((v, i) => (
                                        <>
                                            {
                                                data?.campaignType === 9 && v?.brandProgresses && (
                                                    <Row className={"mt-5 mb-3"}>
                                                        <Col xs={12} md={8} lg={4} className={"mt-4 mx-auto d-flex align-items-center p-2 justify-content-center"}>
                                                            <Row>
                                                                {
                                                                    v?.brandProgresses && (
                                                                        v?.brandProgresses.map((v3, i3) => (
                                                                                <Col xs={true} className={"text-center p-2 m-2 rounded"} key={i3}>
                                                                                    <div style={{height: 30}}>
                                                                                        <img src={v3.image} className={"img-fluid"}/>
                                                                                    </div>
                                                                                    <hr/>
                                                                                    <span>
                                                                                        Hedefe Kalan {" "}
                                                                                        <br/>{" "}
                                                                                        <b>{v3?.remainingQuantity}</b> {" "} Adet
                                                                                    </span>
                                                                                </Col>
                                                                            )
                                                                        )
                                                                    )
                                                                }
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                )
                                            }
                                            <Row className={"pt-3 pb-3"} key={i}>
                                                <Col xs={12} lg={11} className={"mx-auto p-2"}>
                                                    <div className={"campaign-progress-back"} style={{width: "calc((100% / 7) * 7)"}}>
                                                        <div className={"campaign-progress-front"} style={{width: v?.completionPercentage + "%"}}>
                                                            {
                                                                v?.completionPercentage <= 13 && (
                                                                    <>
                                                                        <span>
                                                                            {v?.subTitle ? v?.subTitle : "Hedef"}
                                                                            <br/>
                                                                            {v?.soldQuantity + v?.remainingQuantity} {" "}
                                                                            Adet
                                                                        </span>
                                                                    </>
                                                                )}
                                                            <div className={"percent d-flex align-items-center justify-content-center"}>
                                                                % {v?.completionPercentage}
                                                            </div>
                                                            <div className={"target d-flex align-items-center " + (v?.completionPercentage <= 13 ? "d-none" : "")}>
                                                                {v?.subTitle ? v?.subTitle : "Hedef"}
                                                                <br/>
                                                                {v?.soldQuantity + v?.remainingQuantity}{" "}
                                                                Adet
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col xs={12} lg={3} className={"mx-auto p-2"}>
                                                    <Row>
                                                        <Col xs={true} className={"d-flex align-items-center justify-content-center"}>
                                                            <Row>
                                                                <Col xs={12} className={"text-center"}>
                                                                    Satılan
                                                                </Col>
                                                                <hr/>
                                                                <Col xs={12} className={"text-center"}>
                                                                    <b>{v?.soldQuantity}</b> {" "} Adet
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col xs={true} className={"d-flex align-items-center justify-content-center"}>
                                                            <div className={"row"}>
                                                                <Col xs={12} className={"text-center"}>
                                                                    Kalan
                                                                </Col>
                                                                <hr/>
                                                                <Col xs={12} className={"text-center"}>
                                                                    <b>{v?.remainingQuantity}</b> {" "} Adet
                                                                </Col>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                            <hr/>
                                        </>
                                    ))}
                            </div>
                        </div>
                        {/*
                                <div className={'row '}>
                                    <div
                                        className={"col-md-4 col-12 mx-auto d-flex justify-content-md-center mt-4 mb-4 justify-content-center "}>
                                        <b>Hakediş : </b>&nbsp;  {HelperGeneral.formatMoneyTL(data?.totalProgressPayment)}
                                    </div>
                                </div>
                             */}
                        {/*
                          <div className={'row  '}>
                            <div className={'col-lg-12 col-12 mx-auto '}>
                                <div className={'campaign-chart-m'}>0</div>
                                <div className={'campaign-chart-m'}>40</div>
                                <div className={'campaign-chart-m'}>80</div>
                                <div className={'campaign-chart-m'}>120</div>
                                <div className={'campaign-chart-m'}>160</div>
                                <div className={'campaign-chart-m'}>200</div>
                                <div className={'campaign-chart-m'}>240</div>
                                <div className={'campaign-chart-m'}>260</div>
                            </div>
                        </div>
                            * */}
                    </div>
                </>
            );
        };

        const campaignGraph = (data) => {
            return (
                <>
                    <div className={"product-history "}>
                        <h2 className={"mb-3"}>Kampanya Grafiği</h2>
                        <div className={"w-100 h-100 position-relative"}>
                            {
                                !loading && data.length < 1 ? (
                                    <Empty description={"Kampanya bulunamadı"} className={'mt-5'}/>
                                ) : (
                                    <div className={"w-100 h-100 campaign-chart-back-border position-absolute"}>
                                        <Row className={"h-100"}>
                                            <Col xs={12} lg={6} className={"h-100 mx-auto"}>
                                                <div className={"chart-back-border-column h-100"}/>
                                                <div className={"chart-back-border-column h-100"}/>
                                                <div className={"chart-back-border-column h-100"}/>
                                                <div className={"chart-back-border-column h-100"}/>
                                                <div className={"chart-back-border-column h-100"}/>
                                                <div className={"chart-back-border-column h-100"}/>
                                                <div className={"chart-back-border-column h-100"}/>
                                            </Col>
                                        </Row>
                                    </div>
                                )
                            }

                            <div style={{zIndex: 1, position: "relative"}}>
                                {
                                    data.map((v, i) => (
                                        <Row className={"pt-3 pb-3"}>
                                            <Col xs={12} lg={3} className={"d-flex align-items-center p-2 justify-content-center"}>
                                                {v.name}
                                            </Col>
                                            <Col xs={12} lg={6} className={"p-2"}>
                                                <div className={"campaign-progress-back"} style={{width: "calc((100% / 7) * 7)"}}>
                                                    <div className={"campaign-progress-front"} style={{width: v.completionPercentage + "%"}}>
                                                        <div className={"percent d-flex align-items-center justify-content-center"}>
                                                            % {v.completionPercentage}
                                                        </div>
                                                        <div className={"target d-flex align-items-center "}>
                                                            Hedef <br/> {v.soldQuantity + v.remainingQuantity} {" "} Adet
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col xs={12} lg={3} className={"p-2"}>
                                                <Row>
                                                    <Col xs={6} className={"d-flex align-items-center justify-content-center"}>
                                                        Satılan <br/> {v.soldQuantity} Adet
                                                    </Col>
                                                    <Col xs={6} className={"d-flex align-items-center justify-content-center"}>
                                                        Kalan <br/> {v.remainingQuantity} Adet
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    ))}
                            </div>
                        </div>
                    </div>
                </>
            );
        };

        const campaignCard = (data) => {
            return (
                <Container className={'p-0'}>
                    <Row>
                        {
                            data?.map((v, i) => (
                                <Col xs={12} lg={4} className={"mb-3"} key={i}>
                                    <div className={"box2"}>
                                        <Row>
                                            <Col xs={8} md={3} className={"mb-0 mx-auto img-col"}>
                                                <img
                                                    alt={""}
                                                    src={v?.image && v?.image?.length > 0 ? v?.image : require("../../../assets/images/png/default-product.png")}
                                                    className={"img-thumbnail rounded campaign-img"}
                                                />
                                            </Col>
                                            <Col lg={9} className={"d-flex align-items-center"}>
                                                <span className={"large-font"}>{v?.name}</span>
                                            </Col>
                                            <Col xs={12} className={"mt-2 mb-2"}>
                                                <div className={"campaign-progress-back"} style={{width: "calc((100% / 7) * 7)", height: "14px"}}>
                                                    <div className={"campaign-progress-front"} style={{width: v?.completionPercentage + "%", height: "14px"}}/>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xs={6} className={"d-flex justify-content-start"}>
                                                <span className={"small-font"}>
                                                    {" "} Başlangıç Tarihi <br/> {moment(v?.startDate).format("DD.MM.YYYY")}
                                                </span>
                                            </Col>
                                            <Col xs={6} className={"d-flex justify-content-end text-end"}>
                                                <span className={"small-font"}>
                                                    {" "} Bitiş Tarihi <br/> {moment(v?.endDate).format("DD.MM.YYYY")}
                                                </span>
                                            </Col>
                                        </Row>
                                        <Row className={"mt-4"}>
                                            <Col xs={12} className={"d-flex align-items-center justify-content-end"}>
                                                <Link to={"/campaignDetail/" + v?.id}>
                                                    <span className={"small-font"}>
                                                        {" "} Detaylar {" "} <FontAwesomeIcon icon={faArrowRight} className={"ms-1"}/> {" "}
                                                    </span>
                                                </Link>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            ))
                        }

                        {
                            !loading && data?.length < 1 && (
                                <Empty description={"Kampanya bulunamadı"} className={'mt-5'}/>
                            )
                        }
                    </Row>
                </Container>
            );
        };

        return (
            <div className={"my-account campaign pb-0 pb-sm-5 min-height-container"}>
                <Container>
                    <Row>
                        <Col xs={12} className={"mt-0 mt-sm-3"}>
                            <div className={"tab-area"}>
                                <Spin spinning={loading}>
                                    <Tabs
                                        activeKey={active_tab}
                                        onChange={(active_tab) =>
                                            HelperGeneral.pageChange(
                                                this,
                                                "/campaign/" + active_tab
                                            )
                                        }
                                        tabBarExtraContent={campaignViewSwitch()}
                                        inkBarColor={'black'}
                                    >
                                        <Tabs.TabPane
                                            tab={"Güncel Kampanyalar"}
                                            key={"guncel-kampanyalar"}
                                        >
                                            {this.state.viewType === "card" ? campaignCard(currentCampaigns) : campaignGraph(currentCampaigns)}
                                        </Tabs.TabPane>
                                        <Tabs.TabPane
                                            tab={"Geçmiş Kampanyalar"}
                                            key={"gecmis-kampanyalar"}
                                        >
                                            {this.state.viewType === "card" ? campaignCard(previousCampaigns) : campaignGraph(previousCampaigns)}
                                        </Tabs.TabPane>
                                        <Tabs.TabPane
                                            tab={"Gelecek Kampanyalar"}
                                            key={"gelecek-kampanyalar"}
                                        >
                                            {this.state.viewType === "card" ? campaignCard(futureCampaigns) : campaignGraph(futureCampaigns)}
                                        </Tabs.TabPane>

                                        {
                                            expertBonus.map((v, i) => (
                                                <Tabs.TabPane
                                                    tab={v?.title}
                                                    key={v?.title.toLowerCase().replace(/ /g, "").replace(/[^\w-]+/g, "")}
                                                >
                                                    {expertBonusGraph(v)}
                                                </Tabs.TabPane>
                                            ))
                                        }
                                    </Tabs>
                                </Spin>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    menuData: state.GeneralReducer.menuData,
});

export default withRouter(connect(mapStateToProps)(Campaign));
